import React from 'react';
import {Col, Button} from 'react-bootstrap';
import {CheckCircleFill, Icon, XCircleFill} from "react-bootstrap-icons";


interface CardItem {
    label: string;
    value: string | number | boolean;
}

interface ButtonConfig {
    label: string;
    onClick: () => void;
    icon?: Icon;
    variant?: string;
}

interface ColProps {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
}

interface AdminCardProps {
    icon: Icon;
    items: CardItem[];
    buttonConfig?: ButtonConfig;
    colProps?: ColProps;
}

const GameCard: React.FC<AdminCardProps> = ({
                                                 icon: Icon,
                                                 items,
                                                 buttonConfig,
                                                 colProps = {xs: 12, lg: 4}
                                             }) => {
    const renderValue = (value: CardItem['value']) => {
        if (typeof value === 'boolean') {
            return value ?
                <CheckCircleFill className="text-success"/> :
                <XCircleFill className="text-danger"/>;
        }
        return value;
    };

    return (
        <Col {...colProps} className="mb-4 mb-lg-0">
            <div className='admin-card d-flex align-items-center'>
                <div className='card-icon'>
                    <Icon/>
                </div>
                <div className='card-info'>
                    {items.filter(item => item.value !== null).map((item, index) => (
                        <p key={index}>
                            <span>{item.label}: </span>
                            <span className='card-large-text'>
                                {renderValue(item.value)}
                            </span>
                        </p>
                    ))}
                    {buttonConfig && (
                        <Button
                            variant={buttonConfig.variant || 'outline-primary btn-sm mt-2'}
                            onClick={buttonConfig.onClick}
                        >
                            {buttonConfig.icon && (
                                <buttonConfig.icon className="me-2"/>
                            )}
                            {buttonConfig.label}
                        </Button>
                    )}
                </div>
            </div>
        </Col>
    );
};

export default GameCard;